var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaintainWeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 42,
    height: 42,
    transform: "translate(502 551)",
    fill: "#ebc5c5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#05235d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#305eba"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_8",
    "data-name": "Mask Group 8",
    transform: "translate(-502 -551)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "weights",
    transform: "translate(501.99 550.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M26.7,23.242l-3.954-1.826c-2.4-1.111-5.442.065-7.637,2.67L11.656,22.2c-.766-.356-1.844.3-2.356,1.4a2.853,2.853,0,0,0-.258,1.649,1.339,1.339,0,0,0,.677,1.036l3.2,1.75c-1.322,3.989-.33,7.979,2.487,9.277l3.953,1.825a4.682,4.682,0,0,0,1.976.428,6.321,6.321,0,0,0,3.209-.963,10.821,10.821,0,0,0,4.145-4.8C30.71,29.422,29.818,24.681,26.7,23.242ZM10.37,25.151a.491.491,0,0,1-.034-.12,1.582,1.582,0,0,1,.155-.875,1.387,1.387,0,0,1,.663-.735l3.156,1.727a12.221,12.221,0,0,0-.9,1.605c-.007.017-.013.033-.021.05Zm4.235,2.156c1.721-3.726,5.123-5.831,7.589-4.7l.969.448a7.146,7.146,0,0,0-1.651.719,10.818,10.818,0,0,0-4.145,4.8,10.832,10.832,0,0,0-.97,6.272,7.177,7.177,0,0,0,.525,1.722l-.963-.446C13.489,34.987,12.885,31.029,14.605,27.306Zm12.889,5.951a9.515,9.515,0,0,1-3.623,4.225,4.231,4.231,0,0,1-3.966.469,4.234,4.234,0,0,1-2.213-3.326,9.511,9.511,0,0,1,.866-5.5A9.506,9.506,0,0,1,22.182,24.9a5.034,5.034,0,0,1,2.538-.775,3.386,3.386,0,0,1,1.424.3C28.61,25.571,29.215,29.528,27.494,33.258Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M10.905,31.074a3.938,3.938,0,0,1-3.318.134c-1.425-.658-2.292-2.341-2.319-4.5a.656.656,0,0,0-.656-.648H4.6a.656.656,0,0,0-.648.665,7.762,7.762,0,0,0,.658,3.111l-.98-.452a4.237,4.237,0,0,1-2.214-3.326,9.518,9.518,0,0,1,.867-5.5,9.512,9.512,0,0,1,3.623-4.225,4.239,4.239,0,0,1,3.965-.47l.04.018.951.438a9.909,9.909,0,0,0-5.817,5.514,12.064,12.064,0,0,0-.859,2.575.656.656,0,0,0,.506.778.672.672,0,0,0,.137.014.656.656,0,0,0,.641-.521,10.805,10.805,0,0,1,.767-2.3c1.721-3.725,5.124-5.836,7.589-4.695A4.3,4.3,0,0,1,16.072,21.2a.657.657,0,1,0,1.3-.187,5.631,5.631,0,0,0-2.993-4.517l-3.952-1.827-.044-.018A5.514,5.514,0,0,0,5.24,15.2a10.824,10.824,0,0,0-4.145,4.8c-2.024,4.389-1.133,9.128,1.988,10.57L7.037,32.4A4.668,4.668,0,0,0,9,32.822a5.993,5.993,0,0,0,2.437-.549.657.657,0,1,0-.536-1.2Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M30.859,26.748a.656.656,0,0,0,.016,1.313h.02a4.773,4.773,0,1,0-4.5-6.675.656.656,0,0,0,1.2.525,3.461,3.461,0,1,1,3.261,4.839Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M40.9,5.7a7.021,7.021,0,0,0-5.942-3.254H26.663a7.051,7.051,0,0,0-6.4,10.013l2.213,4.778a10.35,10.35,0,0,0-1.238,2.231.656.656,0,1,0,1.218.488,9.042,9.042,0,0,1,1.258-2.186.3.3,0,0,0,.02-.026A8.889,8.889,0,0,1,25.8,15.833h0c.005,0,.008-.007.013-.009A8.959,8.959,0,1,1,35.3,31.016H30.807a.656.656,0,1,0,0,1.313h4.664a.654.654,0,0,0,.321-.088A10.24,10.24,0,0,0,39.1,17.311l2.249-4.856A7.022,7.022,0,0,0,40.9,5.7ZM40.162,11.9l-1.987,4.288a10.327,10.327,0,0,0-1.281-1.126l1.783-3.851a4.1,4.1,0,0,0-3.721-5.823h-.823a.656.656,0,0,0,0,1.313h.82a2.787,2.787,0,0,1,2.53,3.959l-1.7,3.671a10.258,10.258,0,0,0-9.967-.045l-1.68-3.627A2.787,2.787,0,0,1,26.667,6.7h5.506a.656.656,0,0,0,0-1.313h-5.51a4.1,4.1,0,0,0-3.72,5.824L24.7,15.005a10.19,10.19,0,0,0-1.286,1.118L21.458,11.9a5.736,5.736,0,0,1,5.2-8.149h8.293A5.737,5.737,0,0,1,40.162,11.9Z",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintainWeight);
export default __webpack_public_path__ + "static/media/maintain-weight.003ed0c9cc100c31af9ca16542aede07.svg";
export { ForwardRef as ReactComponent };